import { inject, Injectable } from '@angular/core';
import { ConnectionHttpService } from '@softline/core';
import { FieldOkService } from '@softline/dynamic';
import { Observable } from 'rxjs';

/** Raw field-ok lookup row for a distribution type (endpoint `lieferart`). */
export interface DistributionTypeRow {
  id: number;
  /** Backend field-ok fields (German, from the `lieferart` endpoint). */
  lieferart: string;
  bezeichnung: string;
}

const DEFAULT_PARAMETERS = { aktiv: 'J', kzgueltig: 'G,V' };

@Injectable({ providedIn: 'root' })
export class DistributionTypeService {
  private readonly fieldOkService = new FieldOkService<
    DistributionTypeRow,
    DistributionTypeRow
  >(inject(ConnectionHttpService), 'lieferart');

  query(
    extraParameters: Record<string, unknown> = {}
  ): Observable<DistributionTypeRow[]> {
    return this.fieldOkService.query({
      filter: '',
      multiValued: false,
      parameters: { ...DEFAULT_PARAMETERS, ...extraParameters },
      maxAbfrageResults: 100,
    });
  }

  load(id: number | string): Observable<DistributionTypeRow | null> {
    return this.fieldOkService.load(
      {
        filter: '',
        multiValued: false,
        parameters: { ...DEFAULT_PARAMETERS },
        maxAbfrageResults: 100,
      },
      id
    );
  }
}
